import axios from "../../axios";

const updateBankAccountDevice = async function (accessToken, id, params = {}) {
    try {
        const response = await axios.post('/bank-account/device/updateBankAccountDevice',params, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                id
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateBankAccountDevice;
